import React from 'react';

const LegacyHomeIcon = () => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="21" height="22" viewBox="0 0 21 22" fill="none">
      <path
        d="M7.9572 19.7714V16.7047C7.95719 15.9246 8.59311 15.2908 9.381 15.2856H12.2671C13.0587 15.2856 13.7005 15.9209 13.7005 16.7047V19.7809C13.7003 20.4432 14.2342 20.9845 14.903 21H16.8271C18.7451 21 20.3 19.4607 20.3 17.5618V8.83783C20.2897 8.09083 19.9355 7.38935 19.338 6.93303L12.7577 1.6853C11.6049 0.771566 9.96619 0.771566 8.81341 1.6853L2.26201 6.94256C1.66225 7.39702 1.30737 8.09967 1.29999 8.84736V17.5618C1.29999 19.4607 2.85486 21 4.7729 21H6.69695C7.38234 21 7.93796 20.4499 7.93796 19.7714"
        stroke="#A2A2A2"
        strokeLinecap="round"
        strokeLinejoin="round"
      ></path>
    </svg>
  );
};

export default LegacyHomeIcon;
